import React from 'react'
import PropTypes from 'prop-types'
import { SelectField, MenuItem } from 'material-ui'
import styles from './styles.css'

const hourChoices = [1, 2, 3, 4, 5, 6, 7, 24]

const Scheduling = ({
  reviewsOffset,
  isLoaded,
  updateSetting,
}) => {
  const handleUpdateHours = (e, child) => {
    const newHour = hourChoices[child]
    const offsetInSeconds = newHour * 60 * 60
    updateSetting(offsetInSeconds, null)
  }

  const isTops = process.env.REACT_APP_IS_TOPS
  const hourSelected = isTops ? 24 : reviewsOffset / (60 * 60)
  const floatingLabelText = `${
    hourSelected === 1 ? 'hour' : 'hours'
  } after appointment`

  return (
    <div className="scheduler_container">
      <p>Scheduled to send:</p>
      {isLoaded && reviewsOffset && (
        <SelectField
          floatingLabelFixed
          floatingLabelText={floatingLabelText}
          maxHeight={150}
          value={hourSelected}
          className={styles.selectField}
          onChange={handleUpdateHours}
          disabled={isTops}
        >
          {hourChoices.map(hour => (
            <MenuItem value={hour} primaryText={`${hour}`} key={hour} />
          ))}
        </SelectField>
      )}
    </div>
  )
}

Scheduling.propTypes = {
  reviewsOffset: PropTypes.number,
  isLoaded: PropTypes.bool.isRequired,
  updateSetting: PropTypes.func.isRequired,
}

export default Scheduling



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/Scheduling.js